<app-payment-panel-adyen-generic
  type="mealVoucher_FR_sodexo"
  [isPayButtonVisible]="true"
  [payButtonText]="'payment.pay-with-sodexo' | translate"
  [clientKey]="clientKey"
  [paymentMethodMealVoucherSodexoAvailable]="paymentMethodMealVoucherSodexoAvailable"
  paymentMethodHandle="ADYEN_MEAL_VOUCHER_SODEXO"
>
  <app-payment-panel-adyen-cb-skeleton loadingState></app-payment-panel-adyen-cb-skeleton>
</app-payment-panel-adyen-generic>
